export { default } from './FacilityPage';
